import React from 'react';
import { Link } from 'react-router-dom';
import { resources } from '../data/siteContent';

export default function Resources() {
  return (
    <div className="bg-primary/5 min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-8">
        <header className="space-y-3 text-center">
          <p className="text-sm uppercase tracking-[0.4em] text-gray-500">Resources</p>
          <h1 className="text-4xl font-bold text-charcoal">Guides, blog posts, and trusted insights</h1>
        </header>

        <div className="grid gap-6 md:grid-cols-3">
          {resources.map((resource) => (
            <article key={resource.title} className="rounded-3xl border border-white bg-white/90 p-6 shadow-md">
              <div className="flex items-center justify-between">
                <p className="text-xs uppercase tracking-[0.4em] text-gray-500">{resource.type}</p>
                <span className="text-xs font-semibold text-primary">Request below</span>
              </div>
              <h2 className="mt-3 text-xl font-semibold text-charcoal">{resource.title}</h2>
              <p className="mt-4 text-gray-600 text-sm leading-relaxed">{resource.description}</p>
              <Link to="/contact" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary">
                Request this resource →
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500">Want the full playbook delivered?</p>
          <Link to="/free-assessment" className="mt-3 inline-flex items-center justify-center rounded-full bg-charcoal px-6 py-3 text-sm font-semibold text-white shadow-lg">
            Request a PDF + call
          </Link>
        </div>
      </div>
    </div>
  );
}
